/* global window, moeditor, Intercom */
import PropTypes from 'prop-types';

import React, { Component } from 'react';
import { KEYS, EDITOR_SAVE_BUTTONS_ID } from 'crazyEditor/core/constants/editorConstants';
import { closeStaticPanel } from 'crazyEditor/redux/modules/panel/panel';
import SaveButton from './SaveButton';
import SaveButtonDropDownPanel from './SaveButtonDropDownPanel';
import { MENU_PANELS } from 'crazyEditor/core/constants/panelConstants';
import _ from 'lodash';
import {templateService} from 'shared/helpers/TemplateService';
import EbayService from 'crazyEditor/helpers/EbayService';
import { TYPES, EDITOR_PANELS } from 'crazyEditor/core/constants/panelConstants';
import { openLazyPanel } from 'crazyEditor/redux/modules/panel/panel';
import {openPublishDialog} from 'crazyEditor/redux/modules/publishDialog/publishDialog';
import {updateCSSUrl} from 'crazyEditor/redux/modules/template/template';
import connectWithRouter from 'shared/components/redux/connectWithRouter';

@connectWithRouter(
  state => {
    const itemId = state.routing.location.query.itemId;
    return {
      listingData: !_.isEmpty(state.listingData) ? state.listingData : undefined,
      draft: itemId && itemId.indexOf('DRAFT') === 0,
      itemId: itemId,
      sellerId: state.routing.location.query.selectedSellerId,
    };
  }, {closeStaticPanel, openLazyPanel, openPublishDialog, updateCSSUrl}
)
export default class SaveButtons extends Component {
  static contextTypes = {
    utils: PropTypes.object.isRequired,
    integrationConnector: PropTypes.object.isRequired,
  };

  getProps() {
    const {listingData, draft} = this.props;
    let primaryAction;
    let onPrimaryActionClick;
    if (draft) {
      primaryAction = 'saveDraft';
      onPrimaryActionClick = () => this.saveAndPublish();
    } else if (listingData) {
      primaryAction = 'saveAndRevise';
      onPrimaryActionClick = () => this.saveAndPublish();
    } else {
      primaryAction = 'saveTemplate';
      onPrimaryActionClick = () => this.handleSaveClicked();
    }
    return {
      primaryAction: primaryAction,
      saveAndPublish: this.saveAndPublish,
      saveSiteFail: this.props.saveSiteFail,
      onExit: this.props.onExit,
      verifyUserStatusAndCall: this.context.utils.verifyUserStatusAndCall,
      openPublishDialog: this.openPublishDialog,
      onClickSave: this.handleSaveClicked,
      onPrimaryActionClick,
    };
  }

  saveAndPublish = (openPublishDialog) => {
    const {listingData, draft, itemId, updateCSSUrl, sellerId} = this.props;
    updateCSSUrl(null);
    this.context.utils.verifyUserStatusAndCall(() => {
      EbayService.reviseListing(draft ? {itemID: itemId, draft, sellerId} : listingData).then(() => {
        templateService.preventConfirmNavigation();
        if (openPublishDialog) {
          this.openPublishDialog();
        }
      });
    });
  };

  openPublishDialog = () => {
    const {openPublishDialog} = this.props;
    this.context.utils.verifyUserStatusAndCall(() => {
      openPublishDialog();
    });
  };

  trySave = (andApplyAll = false) => {
    const {integrationConnector} = this.context;
    const {updateCSSUrl} = this.props;
    updateCSSUrl(null);
    return templateService.saveCurrentTemplate(andApplyAll, integrationConnector);
  };

  handleSaveClicked = ({andExit = false, andApplyAll = false, verifyUserStatus = false} = {}) => {
    const {onExit} = this.props;
    if (andApplyAll) {
      verifyUserStatus = true;
    }
    const {trySave} = this;
    const handler = () => {
      trySave(andApplyAll).then(() => {
        if (onExit && andExit) {
          onExit();
        }
      })
        .catch(() => {
        });
    };
    if (verifyUserStatus) {
      this.context.utils.verifyUserStatusAndCall(handler);
    } else {
      handler();
    }
  };

  render() {
    return (
      <span id={EDITOR_SAVE_BUTTONS_ID} style={{display: 'flex'}}>
        <SaveButton {...this.getProps()}/>
        <SaveButtonDropDownPanel {...this.getProps()}/>
      </span>
    );
  }
}